import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[dev-func-confirm-host]'
})
export class DevFuncConfirmDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}